/*
ToastContext.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { createContext } from 'react';
import { Toast, AddToast, RemoveToast } from '../types/toastTypes';


export const ToastContext = createContext<{
  toasts: Toast[];
  addToast: AddToast;
  removeToast: RemoveToast;
  showToasts: boolean;
  setShowToasts: (boolean) => void;
} | null>(null);
